<!-- AbsoluteURL (custom mark) -->
<script lang="ts">
	import type { MarkComponentProps } from '@portabletext/svelte';

	import sanityToPath from '$utils/sanityPath';

	// Property custom marks receive from @portabletext/svelte when redered
	// export let portableText: MarkComponentProps<{
	// 	reference?: any;

	interface Props {
		// }>;
		portableText: MarkComponentProps<{ slug: { current: string }; documentType: string }>;
		children?: import('svelte').Snippet;
	}

	let { portableText, children }: Props = $props();

	// Remember to make your variables reactive so that they can reflect prop changes
	// See: https://svelte.dev/docs#3_$_marks_a_statement_as_reactive

	// This needs the correct prefixes to match the document types
	let href = $derived(
		sanityToPath(portableText.value.documentType, portableText.value.slug.current)
	);
</script>

{#if href}
	<!-- eslint-disable svelte/no-navigation-without-resolve -->
	<a {href} data-sveltekit-preload-data>
		<!-- Marks receive children which you can render with Svelte's slots -->
		{@render children?.()}
	</a>
{:else}
	<!-- If no valid URL, render only the contents of the mark -->
	{@render children?.()}
{/if}
